import Clickable from 'components/Common/Clickable'
import LineInfoCircleIcon from 'LuxKit/Icons/line/LineInfoCircleIcon'
import StatusLabel from 'LuxKit/Label/StatusLabel'
import React, { MouseEventHandler, useCallback } from 'react'
import { connect } from 'react-redux'
import { selectBusinessTravellerCurrentApprovalRequest } from 'businessTraveller/selectors/selectBusinessTravellerCurrentApprovalRequest'

interface Props {
  /**
   * The percentage the budget is exceeded by.
   */
  exceedingPercentage: number
  onClick: MouseEventHandler<HTMLButtonElement>
  currentApprovalRequest?: App.BusinessTraveller.ApprovalRequest
}

function PriceRowBusinessTravellerExceededBudget(props: Props) {
  const {
    exceedingPercentage,
    onClick,
    currentApprovalRequest,
  } = props

  const handleClick = useCallback<MouseEventHandler<HTMLButtonElement>>((event) => {
    event.preventDefault()
    event.stopPropagation()

    onClick(event)
  }, [onClick])

  return <Clickable onClick={handleClick}>
    <StatusLabel variant="pending" endIcon={<LineInfoCircleIcon />}>
      {currentApprovalRequest?.approverId ? `Exceeds approved by ${exceedingPercentage}%` : `Exceeds budget by ${exceedingPercentage}%`}
    </StatusLabel>
  </Clickable>
}

const mapStateToProps = (state: App.State) => ({
  currentApprovalRequest: selectBusinessTravellerCurrentApprovalRequest(state),
})

export default connect(mapStateToProps)(PriceRowBusinessTravellerExceededBudget)
